var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQCart = function SvgQCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.945,
    cy: 19.018,
    r: 1.262,
    stroke: "currentColor",
    strokeWidth: 1.183
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.36,
    cy: 19.018,
    r: 1.262,
    stroke: "currentColor",
    strokeWidth: 1.183
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.794 3.128a.794.794 0 1 0 0 1.59H4.61c.122 0 .229.083.258.202l2.475 10.23a1.854 1.854 0 0 0 1.802 1.419h9.216c.872 0 1.626-.608 1.812-1.46l1.797-8.256a1.324 1.324 0 0 0-1.294-1.606H6.581l-.17-.701a1.854 1.854 0 0 0-1.802-1.418z",
    clipRule: "evenodd"
  })));
};
export { SvgQCart as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8Y2lyY2xlIGN4PSI5Ljk0NTExIiBjeT0iMTkuMDE4IiByPSIxLjI2MjM1IiBmaWxsPSJjdXJyZW50Q29sb3IiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuMTgyOSIvPgo8Y2lyY2xlIGN4PSIxNy4zNjAyIiBjeT0iMTkuMDE4IiByPSIxLjI2MjM1IiBmaWxsPSJjdXJyZW50Q29sb3IiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuMTgyOSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIuNzk0NDkgMy4xMjgxN0MyLjM1NTcgMy4xMjgxNyAyIDMuNDgzODggMiAzLjkyMjY2QzIgNC4zNjE0NCAyLjM1NTcgNC43MTcxNSAyLjc5NDQ5IDQuNzE3MTVINC42MDkyQzQuNzMxNDcgNC43MTcxNSA0LjgzNzg1IDQuODAwODYgNC44NjY2IDQuOTE5N0w3LjM0MjExIDE1LjE1MDlDNy41NDMzOSAxNS45ODI4IDguMjg4MDMgMTYuNTY4OCA5LjE0MzkyIDE2LjU2ODhIMTguMzYwNEMxOS4yMzIyIDE2LjU2ODggMTkuOTg2MyAxNS45NjEyIDIwLjE3MTcgMTUuMTA5M0wyMS45NjkgNi44NTI1OUMyMi4xNDg3IDYuMDI3MTUgMjEuNTE5OSA1LjI0NjgxIDIwLjY3NTIgNS4yNDY4MUg2LjU4MDU4TDYuNDExMDIgNC41NDYwMkM2LjIwOTczIDMuNzE0MTMgNS40NjUxIDMuMTI4MTcgNC42MDkyIDMuMTI4MTdIMi43OTQ0OVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";